import { Controller } from '@hotwired/stimulus';
import TomSelect from 'tom-select';

export default class extends Controller {
  static values = {
    items: Array,
    noSearch: Boolean,
    placeholder: String,
    createLabel: String
  };

  connect() {
    if (!this.element.tomselect) {
      (() => new TomSelect(this.element, this._settingsFactory(this.element)))();
    }
  }

  disconnect() {
    const value = this.element.value;

    this.element.tomselect.destroy();

    // necessary to persist value because
    // this.element.tomselect.destroy() sets the value to null
    this.element.value = value;
  }

  _settingsFactory(element) {
    const ajaxUrl = element.dataset.ajaxUrl;
    const ajaxTextField = element.dataset.ajaxTextField;
    const ajaxValueField = element.dataset.ajaxValueField;
    const ajaxMatcher = element.dataset.ajaxSearchMatcher;
    const ajaxDisplayedField = (
      element.dataset.ajaxDisplayedField ? element.dataset.ajaxDisplayedField : ajaxTextField
    );
    const ajaxAdditionalFilters = (
      element.dataset.ajaxAdditionalFilters
        ? JSON.parse(element.dataset.ajaxAdditionalFilters)
        : []
    );
    const createLabel = this.hasCreateLabelValue ? this.createLabelValue : 'Add';

    const additionalFiltersQuery = ajaxAdditionalFilters.reduce((acc, filter) => {
      return acc + `&q[${filter[0]}]=${filter[1]}`;
    }, '');

    const formatAjaxData = (json, valueField, textField) => {
      return json.map(entry => (
        {
          ...entry,
          value: entry[valueField],
          text: entry[textField]
        }
      ));
    };

    const settingsStore = {
      create: {
        create: input => ({ value: input, text: input }),
        persist: false,
        render: {
          option_create: (data, escape) =>
            `<div class="create">${escape(createLabel)} <strong>${escape(data.input)}</strong>&hellip;</div>`
        }
      },
      ajax: {
        valueField: 'value',
        labelField: 'text',
        // filtering is done server-side (e.g. on name OR email); a constant score disables
        // TomSelect's client-side re-filtering, which would hide options matched by a field
        // that is not part of the displayed text
        score: () => () => 1,
        load: function (query, callback) {
          const url =
            `${ajaxUrl}?q[${ajaxTextField}_${ajaxMatcher}]=${encodeURIComponent(query)}` + `${additionalFiltersQuery}`;
          fetch(url, {
            headers: {
              Accept: 'application/json'
            }
          })
            .then(response => response.json())
            .then(json => {
              this.clearOptions();
              callback(formatAjaxData(json, ajaxValueField, ajaxDisplayedField));
            }).catch((e) => {
              callback();
            });
        }
      }
    };

    const settings = {
      maxOptions: null,
      onItemAdd: function () {
        this.setTextboxValue('');
      },
      plugins: {
        remove_button: {
          title: 'remove'
        }
      },
    };

    if (this.hasItemsValue) { Object.assign(settings, settings, { items: this.itemsValue }); }
    if (element.classList.contains('tom-select-ajax')) { Object.assign(settings, settings, settingsStore.ajax); }
    if (element.classList.contains('tom-select-create')) { Object.assign(settings, settings, settingsStore.create); }
    if (this.hasPlaceholderValue) { Object.assign(settings, settings, { placeholder: this.placeholderValue }); }

    if (this.noSearchValue) {
      Object.assign(settings, settings, {
        onInitialize: function () {
          const input = this.control_input;
          if (input) {
            input.setAttribute('readonly', true);
            input.style.caretColor = 'transparent';
          }
        }
      });
    }

    return settings;
  }
}
